const Toast = ({ children }: { children: React.ReactNode }) => (
  <div className="md:z-99 addresses-alert fixed bottom-6 right-1/2 w-screen max-w-md translate-x-1/2 px-6 md:bottom-8 md:right-8 md:translate-x-0">
    {children}
  </div>
);

export { Toast };
